<script setup>
import fiveMixin from '@/composables/fiveMixin';
import useFunctions from '@/composables/useFunctions';

const { ...five } = fiveMixin();
const { ...useFun } = useFunctions();
const props = defineProps({
  prBirthData: {
    type: Object,
    default: null,
  },
  prBirthJijanggan: {
    type: Object,
    default: () => ({}),
  },
  prLangMode: {
    type: String,
    default: '',
  },
  prBirthTitle: {
    type: String,
    default: '',
  },
  prType: {
    type: String,
    default: '',
  },
  prCurDaeun: {
    type: Object,
    default: () => ({}),
  },
  prTransdata: {
    type: Object,
    default: () => ({}),
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  selectedData: {
    type: Object,
    default: () => ({}),
  },
  prPositionData:{
    type: String,
  },
})

onMounted( () => {

});

function getYearSix(data, pos) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.six;
  return txt;
}
function getPosEng(pos) {
  let txt = '';
  if (pos === '년') txt = 'year';
  if (pos === '월') txt = 'month';
  if (pos === '일') txt = 'day';
  if (pos === '시') txt = 'hour';
  return txt;
}
function getValueTxt(data, pos, val) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.[val];
  if (val === 'sal') {
    txt = txt ? txt[0] : '';
  }
  return txt;
}
function getValueTxtOne(data, pos, val, index) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.[val]?.[index];
  return txt;
}

// 오행도 클릭에 따른 스타일 적용
const getGlobalIdx = (type, title, prBirthTitle) => {
  const posEng = getPosEng(title);
  const idxMap = {
    sky: { year: 0, month: 1, day: 2, hour: 3 },
    earth: { year: 4, month: 5, day: 6, hour: 7 },
  };
  // 현재 prBirthTitle에서 title의 위치 찾기
  const titleIndex = prBirthTitle.indexOf(title);
  if (titleIndex === -1) return null;
  // 해당 title에 맞는 globalIdx 반환
  return idxMap[type][posEng];
};

const getClass = (type, title, prBirthTitle) => {
  if (!props.isActive || props.selectedData === null) return '';
  if (props.activePage != 'page1') return '';
  const currentIdx = getGlobalIdx(type, title, prBirthTitle);
  // 조건별 클래스 추가
  const classes = [];
  if (currentIdx === props.selectedData) {
    if (currentIdx === 2) {
      // sky의 day일 경우 특별 스타일 적용
      classes.push('ilgan');
    }
  } else {
    // 매칭되지 않은 요소
    classes.push('inactive-wongook');
  }
  return classes.join(' ');
};

function getPosKey(pos) {
  if (pos === '시') return 'ss'
  if (pos === '일') return 'dd'
  if (pos === '월') return 'mm'
  if (pos === '년') return 'yy'
  return ''
}

// 기호 클래스 매핑 함수
function getSymbolClass(positionData, posChar) {
  const key = getPosKey(posChar)
  const symbol = positionData?.[key]
  const resultClass =
    symbol === '○' ? 'symbol-circle'
    :  symbol === '●' ? 'symbol-circle-filled'
    : symbol === '△' ? 'symbol-triangle'
    : symbol === 'X' ? 'symbol-x'
    : ''

  return resultClass
}

</script>

<template>
  <div class=" saju-summary__eight">
    <ul
      v-for="(char, index) in prBirthTitle"
      :key="index"
      class="birth-item-box birth txt-big"
    >
      <li>
        <span class="txt1">
          {{ char }}
        </span>
      </li>

      <li>
        <div
          class="symbol-icon"
          :class="getSymbolClass(prPositionData.cc, char)"
        ></div>
      </li>

      <li>
        <span
          class="txt-round xl"
          :class="[
            five.getColorFive(getValueTxt(prBirthData?.sky, char, 'value' )), 
            getClass('sky', char, prBirthTitle),
            prLangMode === 'CHNKOR' ? 'chnkor' : '', prLangMode,
          ]"
        >
          <em
            v-if="prLangMode === 'CHNKOR'"
            class="chn"
          > 
          {{ five.getHanjaTxt(getValueTxt(prBirthData?.sky, char, 'value' ), 'sky') }} 
        </em>
          <em v-if="getValueTxt(prBirthData?.sky, char, 'value' ) === '-'" class="time-none">{{ getValueTxt(prBirthData?.sky, char, 'value' ) }}</em>
          <em v-else class="txt-main">{{ getValueTxt(prBirthData?.sky, char, 'value' ) }}</em>
        </span>
      </li>

      <li>
        <span
          class="txt-round xl mb6"
          :class="[five.getColorFive(getValueTxt(prBirthData?.earth, char, 'value' )), 
          getClass('earth', char, prBirthTitle),
          prLangMode === 'CHNKOR' ? 'chnkor' : '', prLangMode,
          ]"
        >
          <em
            v-if="prLangMode === 'CHNKOR'"
            class="chn"
          > {{ five.getHanjaTxt(getValueTxt(prBirthData?.earth, char, 'value' ), 'earth') }} </em>
          <em v-if="getValueTxt(prBirthData?.sky, char, 'value' ) === '-'" class="time-none">{{ getValueTxt(prBirthData?.sky, char, 'value' ) }}</em>
          <em v-else class="txt-main">{{ getValueTxt(prBirthData?.earth, char, 'value' ) }}</em>
        </span>
      </li>

      <li>
        <div
          class="symbol-icon"
          :class="getSymbolClass(prPositionData.gg, char)"
        ></div>
      </li>

    </ul>
  </div>
</template>
<style lang="scss" scoped>
.symbol-icon {
  width: 20px;
  height: 20px;
  background-size: contain;
  margin: 4px auto;
  &.symbol-circle {
    background: url('@manseImages/yongsin-circle.svg')center center no-repeat;
  }
  &.symbol-circle-filled {
    background: url('@manseImages/yongsin-circle-filled.svg')center center no-repeat; // 추후 아이콘 수정
  }
  &.symbol-triangle {
    background: url('@manseImages/yongsin-triangle.svg')center center no-repeat;
  }
  &.symbol-x {
    background: url('@manseImages/yongsin-x.svg')center center no-repeat;
  }
}

</style>